import React from "react";
import AdminLayout from "./AdminLayout";
import RoomManagement from "../../components/Admin/RoomManagement";

const RoomsPage = () => {
  return (
    <AdminLayout>
      <RoomManagement />
    </AdminLayout>
  );
};

export default RoomsPage;
